import { z } from 'zod'
import { nullableCalendarDaySchema } from '../validators/calendar-day.validator.js'

/**
 * A summary of one version of a venue space's settings, for version switchers
 * and timelines. `effectiveFrom` is the date the version takes effect (`null`
 * for the original, which is treated as "always"). Events inherit the version
 * effective on their date until they are locked.
 *
 * A **calendar day** (`yyyy-MM-dd`), not a timestamp. It was an ISO datetime
 * whose time was always midnight, which meant a day pretending to be an instant
 * — the app sliced the first ten characters off one end and appended
 * `T00:00:00.000Z` at the other. The column is a Postgres `date` now and the
 * wire says the same thing. See `docs/event-scheduling.md`.
 */
export const spaceVersionSummarySchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
  effectiveFrom: nullableCalendarDaySchema,
  isOriginal: z.boolean(),
})

export type SpaceVersionSummary = z.infer<typeof spaceVersionSummarySchema>
